import type { JSX } from "react";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import RenderMark from "../../shared/components/RenderMark";
import ShowError from "../components/ShowError";
import { graphql } from "../gql";

const query = graphql(`
    query TeamScanTermsQuery {
        doc(id: "player.terms.terms") {
            id
            content
        }
    }
`);

function Terms(): JSX.Element {
    const [result] = useQuery({ query });

    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }
    return <RenderMark content={result.data.doc.content} unsafe />;
}

export default Terms;
